import React from 'react';
import { colors } from 'styleguide';

interface GridProps {
  width?: number;
  height?: number;
  color?: {
    primrary: string;
    secondary: string;
  };
}

const Grid = ({
  width = 48,
  color = { primrary: '#9498A7', secondary: colors('neutral', 3) },
}: GridProps) => (
  <svg width={width} viewBox="0 0 48 48" fill="none">
    <rect
      x="21.5"
      y="0.5"
      width="21"
      height="21"
      rx="1.5"
      transform="rotate(90 21.5 0.5)"
      stroke={color.primrary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <rect
      x="21.5"
      y="26.5"
      width="21"
      height="21"
      rx="1.5"
      transform="rotate(90 21.5 26.5)"
      stroke={color.secondary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <rect
      x="47.5"
      y="0.5"
      width="21"
      height="21"
      rx="1.5"
      transform="rotate(90 47.5 0.5)"
      stroke={color.secondary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
    <rect
      x="47.5"
      y="26.5"
      width="21"
      height="21"
      rx="1.5"
      transform="rotate(90 47.5 26.5)"
      stroke={color.secondary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4"
    />
  </svg>
);

export default Grid;
